import React from 'react';
import styled from 'styled-components';
import authService from '../services/authService';

// Define logo URLs with paths to public assets folder
const LOGO_URL = "/assets/Hyundai_Logo_Stacked_CMYK.jpg";
const SUBTITLE_LOGO_URL = "/assets/HPP_2016_LOGO_PRIMARY.jpg";

const Header = () => {
  const handleLogout = () => {
    try {
      // Call the logout function from the auth service
      console.log("Logging out user...");
      authService.logout();
      
      // The logout function will handle the redirect to the login page
    } catch (error) {
      console.error("Error during logout:", error);
      
      // Fallback logout approach if the main one fails
      localStorage.removeItem('okta-token');
      localStorage.removeItem('okta-id-token');
      window.location.href = '/login';
    }
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <HeaderLogo>
          <LogoStack>
            <HyundaiLogo src={LOGO_URL} alt="Hyundai Logo" />
            <SubtitleLogo src={SUBTITLE_LOGO_URL} alt="Subtitle Logo" />
          </LogoStack>
          <PortalTitle>Hyundai Call Recording Portal</PortalTitle>
        </HeaderLogo>
        <LogoutButton onClick={handleLogout} title="Logout">
          <i className="fas fa-sign-out-alt"></i>
          Logout
        </LogoutButton>
      </HeaderContent>
    </HeaderContainer>
  );
};

// Styled Components
const HeaderContainer = styled.header`
  background: var(--glass-bg);
  padding: 20px 30px;
  border-radius: 16px;
  box-shadow: var(--shadow);
  margin-bottom: 30px;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const HeaderLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const LogoStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

const HyundaiLogo = styled.img`
  width: 100px;
  height: auto;
`;

const SubtitleLogo = styled.img`
  width: 100px;
  height: auto;
`;

const PortalTitle = styled.h1`
  color: var(--primary-color);
  font-size: 24px;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const LogoutButton = styled.button`
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: var(--transition);
  
  &:hover {
    background: var(--secondary-color);
    transform: translateY(-2px);
  }
  
  i {
    font-size: 16px;
  }
`;

export default Header; 